import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AuthNavbar() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 968);
  const location = useLocation();
  const navigate = useNavigate(); // Get the navigate function
  const { t } = useTranslation();

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 968);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "80px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: isMobile ? "24px" : "48px",
        paddingRight: isMobile ? "24px" : "48px",
        zIndex: 10,
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: "transparent",
        pointerEvents: "auto",
      }}
    >
      {/* Logo - Left Side */}
      <div onClick={handleLogoClick} style={{ cursor: "pointer" }}>
        <img
          src="/images/joglo.png"
          alt="djoglo logo"
          style={{
            height: isMobile ? "40px" : "50px",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Register/Login Link - Right Side */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontSize: "14px",
          color: "#718096",
        }}
      >
        {location.pathname === "/login" ? (
          <>
            <span>{t("navbar.no_account")}</span>
            <a
              href="/register"
              style={{
                color: "#1976d2",
                fontWeight: "600",
                textDecoration: "none",
              }}
            >
              {t("navbar.signup_button")}
            </a>
          </>
        ) : (
          <>
            <span>{t("navbar.already_have_account")}</span>
            <a
              href="/login"
              style={{
                color: "#1976d2",
                fontWeight: "600",
                textDecoration: "none",
              }}
            >
              {t("navbar.login_button")}
            </a>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthNavbar;
